module.exports = __webpack_public_path__ + "img/communication12.8e93698b.png";